import isMobile from 'is-mobile';
import config from '../startup/config';

type OrientationLock = 'portrait' | 'landscape' | false;

export default class Orientation {
    private lock: OrientationLock;

    constructor() {
        this.lock = config.lockOrientation as OrientationLock;

        if (!this.lock || !isMobile({ tablet: true })) return;

        this.init();
    }

    private init(): void {
        const image = `url(assets/images/web/play_${this.lock}.png)`;
        const div = document.getElementById('turn');

        if (!div) return;

        div.style.backgroundImage = image;

        if (!this.isCorrect) {
            div.style.display = 'block';
            window.onresize = () => {
                if (this.isCorrect) window.location.reload();
            };
        } else {
            window.onresize = () => {
                let display = this.isCorrect ? 'none' : 'block';
                div.style.display = display;
            };
        }
    }

    get isCorrect() {
        if (window.innerWidth > window.innerHeight) {
            return this.lock === 'landscape';
        } else {
            return this.lock === 'portrait';
        }
    }
}
